import React, { useCallback, useRef, useMemo } from 'react'
import {
  MCPaymentsTable,
  MCPaymentsTableRef,
} from 'src/components/mc-payment/payments-table/MCPaymentsTable'
import { ReloadWrapper } from 'src/components/wrapper/reload-wrapper/ReloadWrapper'
import { Typography } from '@mui/material'
import tw from 'twin.macro'
import { TabsSelector } from 'src/components/shared/tabs-selector/TabsSelector'
import { useSelector } from 'react-redux'
import { getAccessInfo } from 'src/selectors/user'
import { UserProductName } from 'src/constants/user'
import {
  PaymentsTable,
  PaymentsTableRef,
} from 'src/components/payment/payments-table/PaymentsTable'

type PaymentTab = 'contractors' | 'master-contractors'

const tabs: { label: string; value: PaymentTab }[] = [
  { label: 'Contractors', value: 'contractors' },
  { label: 'Master Contractors', value: 'master-contractors' },
]

export const Payments = () => {
  const [selectedPaymentTab, setSelectedPaymentTab] = React.useState<PaymentTab>('contractors')

  const paymentsTableRef = useRef<PaymentsTableRef>(null)
  const mcPaymentsTableRef = useRef<MCPaymentsTableRef>(null)

  const accessInfo = useSelector(getAccessInfo)

  const hasSubcontractorProduct = useMemo(
    () => accessInfo?.products?.some((item) => item.product === UserProductName.Subcontractor),
    [accessInfo],
  )

  const handleRefreshPayments = useCallback(async () => {
    await paymentsTableRef.current?.refreshPayments()
  }, [])

  const handleRefreshMCPayments = useCallback(async () => {
    await mcPaymentsTableRef.current?.refreshMCPayments()
  }, [])

  return (
    <ReloadWrapper>
      <div>
        {hasSubcontractorProduct && (
          <div css={tw`flex items-end justify-between flex-col mb-4`}>
            <div css={tw`flex flex-row w-full`}>
              <Typography variant="h2" css={tw`mr-4`}>
                Settlements
              </Typography>
              <TabsSelector<PaymentTab>
                selectedValue={selectedPaymentTab}
                onSelect={setSelectedPaymentTab}
                options={tabs}
              />
            </div>
          </div>
        )}
        {selectedPaymentTab === 'contractors' && (
          <PaymentsTable ref={paymentsTableRef} onRefreshMCPayments={handleRefreshMCPayments} />
        )}
        {selectedPaymentTab === 'master-contractors' && (
          <MCPaymentsTable ref={mcPaymentsTableRef} onRefreshPayments={handleRefreshPayments} />
        )}
      </div>
    </ReloadWrapper>
  )
}
